import { ColumnDef } from "@tanstack/react-table";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { DataTableColumnHeader } from "./data-table-column-header";
import { DataTableRowActions } from "./data-table-row-actions";
import { ITaxHistory } from "@/@types/tax-history";
import { TaxTypeEnum, TaxTypeRequestEnum } from "@/enum/tax-history";

const taxTypeRequestMap: Record<TaxTypeRequestEnum, string> = {
  CREATION: "Criação",
  UPDATE: "Alteração",
  DELETE: "Exclusão",
};

const taxTypeMap: Record<TaxTypeEnum, string> = {
  GNRE: "Gnre",
  SPED: "Sped",
  NFF: "Nff",
  NCM: "Ncm",
};
export const columns: ColumnDef<ITaxHistory>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
  },
  {
    accessorKey: "email",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Email" />
    ),
    cell: ({ row }) => row.original.email,
  },
  {
    accessorKey: "responsible",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Responsável" />
    ),
    cell: ({ row }) => row.original.responsible,
  },
  {
    accessorKey: "tax_type_request",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Solicitação" />
    ),
    cell: ({ row }) =>
      taxTypeRequestMap[row.original.tax_type_request as TaxTypeRequestEnum] ||
      "Desconhecido",
  },
  {
    accessorKey: "type",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Tipo" />
    ),
    cell: ({ row }) =>
      taxTypeMap[row.original.type as TaxTypeEnum] || "Desconhecido",
  },

  {
    accessorKey: "created_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Criado Em" />
    ),
    cell: ({ row }) => {
      const dateString = row.getValue("created_at") as string;
      if (!dateString) return "";

      try {
        const parsedDate = parseISO(dateString);
        return format(parsedDate, "dd/MM/yyyy HH:mm:ss", { locale: ptBR });
      } catch (error) {
        return "Data Inválida";
      }
    },
  },

  {
    id: "actions",
    header: "Ações",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
